import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";

type AddDatasetCardProps = {
  children: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
  dataLoc?: string;
};

type SubComponents = {
  Title: React.FC<{ children: React.ReactNode }>;
  Description: React.FC<{ children: React.ReactNode }>;
  Detail: React.FC<{ children: React.ReactNode; icon?: IconProp }>;
};

export const AddDatasetCard: React.FC<AddDatasetCardProps> & SubComponents = ({
  children,
  selected,
  onClick,
  dataLoc,
  ...rest
}) => {
  return (
    <button
      {...rest}
      aria-pressed={selected}
      className={twJoin(
        "group w-full cursor-pointer space-y-1 rounded-lg border px-4 py-3 text-left transition-all",
        "hover:bg-indigo-25 hover:border-indigo-300",
        !selected && "border-gray-200",
        selected && "border-indigo-200 bg-indigo-50",
      )}
      data-loc={dataLoc}
      data-selected={selected}
      type="button"
      onClick={onClick}
    >
      {children}
    </button>
  );
};

AddDatasetCard.Title = ({ children }) => (
  <div className="text-gray-800 font-inter-semibold-14px group-data-[selected=true]:text-indigo-600">
    {children}
  </div>
);

AddDatasetCard.Description = ({ children }) => (
  <div className="text-gray-500 font-inter-normal-12px">{children}</div>
);

AddDatasetCard.Detail = ({ children, icon }) => (
  <div className="flex items-center gap-1 text-sm text-gray-500 font-inter-normal-12px">
    {icon && <Icon color="text-gray-500" icon={icon} size="xs" />}
    {children}
  </div>
);
